import { useEffect, useState } from "react";
import "./App.css";
import Header from "./components/Header/Header";
import Learn from "./components/Learn/Learn";
import PlayerStore from "./hooks/PlayerStore";
import NoSleep from "nosleep.js";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const noSleep = new NoSleep();
    noSleep.enable();

    if (!token) {
      window.location.href = "/auth/login";

      return;
    }

    setIsLoggedIn(true);

    return () => {
      noSleep.disable();
    };
  }, []);

  return (
    <>
      {isLoggedIn && (
        <div className="App px-2">
          <PlayerStore>
            <Header />
            <Learn />
          </PlayerStore>
        </div>
      )}
    </>
  );
}

export default App;
